import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../apiConfig";
import styles from "./ProfilesListPage.module.css";
import { convertToAmPm, getProfileStatus } from "../utils/timeUtils";
import bubbleStyles from "../styles/Bubbles.module.css";
import defaultThumb from "../assets/images/default.png";
import ContactSection from "./ContactSection"; // Adjust path if needed
import ProfileStatus from "../components/ProfileStatus";

function ProfilesListPage() {
  const [announcements, setAnnouncements] = useState([]);
  const [profiles, setProfiles] = useState([]);
  const [contact, setContact] = useState(null);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/announcements`)
      .then((res) => setAnnouncements(res.data))
      .catch((err) => console.error("Error fetching announcements:", err));
  }, []);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/profiles`)
      .then((response) => setProfiles(response.data))
      .catch((error) => console.error("Error fetching profiles:", error));
  }, []);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/api/contact`)
      .then((response) => setContact(response.data))
      .catch((error) => console.error("Error fetching contact:", error));
  }, []);

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.profilesListContainer}>
        {/* Announcements */}
        {announcements.length > 0 && (
          <div className={styles.card}>
            <h2>Announcements</h2>
            <ul className={styles.announcementList}>
              {announcements.map((item) => (
                <li key={item.id}>{item.announcement}</li>
              ))}
            </ul>
          </div>
        )}

        {/* Profiles */}
        <ul className={styles.profileGrid}>
          {profiles.map((profile) => (
            <li key={profile.id} className={styles.profileRow}>
              <div className={styles.card}>
                <Link
                  to={`/profiles/${profile.id}`}
                  className={styles.profileLink}
                >
                  <div className={styles.profileGridLayout}>
                    <img
                      src={
                        profile.profileThumbnail
                          ? `https://khoneymoon-bucket.s3.us-west-1.amazonaws.com/${profile.id}/${profile.profileThumbnail}`
                          : defaultThumb
                      }
                      alt={profile.name}
                      className={styles.profileThumbnail}
                    />
                    <div className={styles.profileDetails}>
                      <h2 className={styles.profileName}>{profile.name}</h2>
                      <ProfileStatus profile={profile} />

                      {profile.announcements?.length > 0 && (
                        <>
                          <hr className={styles.sectionLine} />

                          <ul className={styles.announcementList}>
                            {profile.announcements.map((item) => (
                              <li key={item.id}>{item.announcement}</li>
                            ))}
                          </ul>
                        </>
                      )}

                      {/* LOCATION BLOCK */}
                      <div
                        className={`${bubbleStyles.bubbleStyle} ${bubbleStyles.contactWrapper}`}
                      >
                        <span className={styles.contactIcon}>📍</span>
                        {profile?.location?.googleMapsUrl &&
                        profile?.location?.name ? (
                          <a
                            href={profile.location.googleMapsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {profile.location.name}
                          </a>
                        ) : (
                          <span>Location unavailable</span>
                        )}
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </li>
          ))}
        </ul>

        {/* 📞 Contact Section */}
        <div className={styles.card}>
          <ContactSection contact={contact} />
        </div>
      </div>
    </div>
  );
}

export default ProfilesListPage;
